import { Component, Input, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { UserVipData } from '../../interfaces/vip.interface';

@Component({
  selector: 'app-progress-bar',
  standalone: true,
  imports: [PipesModule],
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
})
export class ProgressBarComponent implements OnInit {
  //用户vip信息
  userVipInfo?: UserVipData | null;
  maxLevel: number = 9;
  @Input() isLeftMenu = false;
  get vipProgress(): number {
    return (this.userVipInfo?.process || 0) > 100 ? 100 : this.userVipInfo?.process || 0;
  }

  get nextLevelPoint(): number {
    const nextLevelPoint = (this.userVipInfo?.nextLevelPoints || 0) - (this.userVipInfo?.currentPoints || 0);
    const roundedNextLevelPoint = Math.round(nextLevelPoint * 100) / 100; // 保留兩位小數
    return roundedNextLevelPoint < 0 ? 0 : roundedNextLevelPoint;
  }

  get currentLevel(): number | null {
    return this.userVipInfo?.currentVipLevel ?? null;
  }

  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.appService.vipUserInfo$.subscribe((data: UserVipData | null) => {
      this.userVipInfo = data;
    });
  }
}
